import produce from 'immer'
import { get, isBoolean } from 'lodash'
import {
  SET_HOME_FETCH_ID,
  SET_HOME_FROM_CACHE,
  SET_CLIENT_FETCH_ID,
  FETCH_HOME_REQUEST,
  FETCH_HOME_SUCCESS,
  FETCH_HOME_FAILURE,
  HOME_DIGEST_UNSUBSCRIBE,
  HOME_DIGEST_SUBSCRIBE,
  ADD_HOME_ANSWER_SUCCESS,
  UPDATE_LOAN_BALANCES_REQUEST,
  UPDATE_LOAN_BALANCES_FAILURE
} from 'src/actions/actionTypes'
import { getHomeUserFromEmail } from 'src/store/selectors/home'
import { getAuthEmail } from 'src/auth'

export const initialState = {
  fetchId: null,
  loading: true,
  data: null,
  cache: {},
  error: null,
  isUnsubscribed: undefined, // Key is used to store last known response w/o fetch
  errorModal: false,
  notFound: false,
  updateLoanBalanceRequested: false
}

export default (
  state = initialState,
  { type, data, error, id, keepCache = false, loading = false }
) =>
  produce(state, draft => {
    const assignDraft = params => Object.assign(draft, params)

    switch (type) {
      case SET_HOME_FETCH_ID: {
        const cache = draft.cache
        if (draft.data && id !== draft.data.id) {
          assignDraft(initialState)
          draft.cache = keepCache ? cache : {}
        }
        draft.fetchId = id
        break
      }
      case SET_HOME_FROM_CACHE: {
        const homeData = state.cache[id]

        if (homeData) {
          draft.data = homeData
        } else {
          assignDraft(initialState)
        }
        draft.fetchId = id
        break
      }

      case SET_CLIENT_FETCH_ID:
        assignDraft(initialState)
        break

      case FETCH_HOME_REQUEST:
        draft.loading = loading
        draft.errorModal = false
        draft.notFound = false
        break

      case FETCH_HOME_SUCCESS: {
        const user = getHomeUserFromEmail(data, getAuthEmail())
        let isUnsubscribed

        if (user) {
          isUnsubscribed = get(user, 'digestEmailUnsubscribed')
        }

        if (isBoolean(state.isUnsubscribed)) {
          isUnsubscribed = state.isUnsubscribed
        }

        draft.cache[data.id] = data
        if (state.fetchId === data.id) {
          assignDraft({
            loading: false,
            updateLoanBalanceRequested: false,
            data,
            isUnsubscribed
          })
        }
        break
      }

      case FETCH_HOME_FAILURE:
        switch (get(error, 'response.status')) {
          case 401:
            draft.errorModal = true
            break

          case 404:
            draft.notFound = true
            break

          default:
            draft.errorModal = true
            break
        }
        break

      case HOME_DIGEST_UNSUBSCRIBE:
        draft.isUnsubscribed = true
        break

      case HOME_DIGEST_SUBSCRIBE:
        draft.isUnsubscribed = false
        break

      case ADD_HOME_ANSWER_SUCCESS:
        Object.assign(draft.data.answers, data.home.answers)
        break

      case UPDATE_LOAN_BALANCES_REQUEST:
        draft.updateLoanBalanceRequested = true
        break

      case UPDATE_LOAN_BALANCES_FAILURE:
        draft.updateLoanBalanceRequested = false
        break

      default:
        break
    }
  })
